import React, { SVGProps } from 'react'

import { IconTemplateIPortIcon } from '@/shared/lib/@deprecated/iport-icons/template/IconTemplateIPortIcon'
import { CustomIconProps } from '@/shared/ui/icon-template'

export const SvgArrow = (props: SVGProps<SVGSVGElement> & CustomIconProps) => {
	return (
		<IconTemplateIPortIcon {...props}>
			<svg viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g id="arrow">
					<path
						id="Icon"
						fillRule="evenodd"
						clipRule="evenodd"
						d="M9.21413 19.2796C9.47158 19.5646 9.91906 19.5643 10.176 19.2789L15.6775 13.1691C16.02 12.7888 16.02 12.2112 15.6775 11.8309L10.233 5.78436C9.94553 5.46515 9.44505 5.46475 9.15711 5.7835C8.90798 6.05929 8.90798 6.47887 9.15711 6.75466L14.0444 12.1648C14.2163 12.3552 14.2163 12.6448 14.0444 12.8352L9.21413 18.1822C8.93261 18.4939 8.93261 18.968 9.21413 19.2796Z"
						fill="#568DFE"
					/>
				</g>
			</svg>
		</IconTemplateIPortIcon>
	)
}

export default SvgArrow
